import { defineComponent } from '@vue/composition-api';
import { ReportMenuItems } from '@/views/Brand/Applications/Components/ReportMenu';
export default defineComponent({
    name: 'ReportsBottomNavigation',
    components: { ReportMenuItems },
});
